import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { BaseFormLayoutComponent } from './base-form-layout.component';
import { CollapsibleBoxModule } from '@components/collapsible-box/collapsible-box.module';
import { HelpBoxModule } from '@components/help-box/help-box.module';
import { BreadcrumbModule } from 'xng-breadcrumb';
import { FooterModule } from '@components/footer/footer.module';
import { ScrollTrackerModule } from '@directives/scroll-tracker/scroll-tracker.module';
import { RouterModule } from '@angular/router';
import { Utils } from '@common/utils/utils';


@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    RouterModule,
    CollapsibleBoxModule,
    HelpBoxModule,
    BreadcrumbModule,
    FooterModule,
    ScrollTrackerModule,
  ],
  providers: [
    Utils,
  ],
  declarations: [BaseFormLayoutComponent],
  exports: [BaseFormLayoutComponent]
})
export class BaseFormLayoutModule {}
